

export default function spaces() {

  return editor => {

    function onTextChanging({ contents, change, selection, oldSelection }) {
      if (selection && change.ops.length <= 2 && change.ops[change.ops.length - 1].insert === ' ') {
        const text = contents.slice(0, selection[0] + 1)
          .map(op => typeof op.insert === 'string' ? op.insert : '\0').join('');

        if (/  [^ ]?$/.test(text)) {
          const firefoxBug = oldSelection[0] === oldSelection[1]
            && selection[0] === selection[1]
            && selection[0] - oldSelection[0] === 2;

          if (/ $/.test(text)) {
            editor.setSelection(selection);
          } else if (firefoxBug && / \n$/.test(text)) {
            editor.setSelection([ selection[0] - 1, selection[1] - 1 ]);
          }
          return false;
        }
      }
    }

    editor.on('text-changing', onTextChanging);

    return {
      onDestroy() {
        editor.off('text-changing', onTextChanging);
      }
    }
  };
}
